import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import * as Sentry from "@sentry/react";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Captures errors to Sentry in production, logs to console in development.
 * Use for critical paths: auth, submissions, API/edge function failures.
 * Avoid capturing the same error in multiple handlers (e.g. mutationFn + onError).
 *
 * @param error - The error to capture (can be Error, string, or unknown)
 * @param context - Optional context object to include with the error
 * @param tags - Optional tags to attach to the error
 */
export function captureError(
  error: unknown,
  context?: Record<string, unknown>,
  tags?: Record<string, string>
): void {
  // Vite automatically sets import.meta.env.DEV to true in development mode
  if (import.meta.env.DEV) {
    console.error("[captureError]", error, { context, tags });
  } else {
    // Capture to Sentry in production
    Sentry.captureException(error, {
      contexts: context ? { custom: context } : undefined,
      tags,
    });
  }
}
